export default "__VITE_ASSET__CfZDkXQU__"